import AddPage from 'pages/add-page'
import MediaZip from 'pages/addmediazip'
import Brands from 'pages/brands'
import BulkProductUpdate from 'pages/bulk-product-update'
import Categories from 'pages/categories'
import Customers from 'pages/customers'
import Dashboard from 'pages/dashboard'
import DealDetails from 'pages/deal-details'
import Deals from 'pages/deals'
import EditBrand from 'pages/edit-brand'
import EditNewCustomer from 'pages/edit-new-customer'
import EditPage from 'pages/edit-page'
import EditProduct from 'pages/edit-product'
import NewCustomer from 'pages/newcustomer'
import OrderDetails from 'pages/order-details'
import Orders from 'pages/orders'
import Pages from 'pages/page'
import Products from 'pages/products'
import UserProfile from 'pages/profile'
import Setting from 'pages/setting'

import { routes } from 'utils/routes'

const PrivateRoutes = [
  { path: routes.profile, exact: true, name: 'Profile', component: UserProfile },
  { path: routes.orders, exact: true, name: 'Orders', component: Orders },
  { path: `${routes.orders}/:id`, exact: true, name: 'OrderDetails', component: OrderDetails },
  { path: routes.products, exact: true, name: 'Products', component: Products },
  { path: `${routes.products}/:id`, exact: true, name: 'EditProduct', component: EditProduct },
  { path: routes.deals, exact: true, name: 'Deals', component: Deals },
  { path: `${routes.deals}/:id`, exact: true, name: 'DealDetails', component: DealDetails },
  { path: routes.brands, exact: true, name: 'Brands', component: Brands },
  { path: `${routes.brands}/:id`, exact: true, name: 'EditBrand', component: EditBrand },
  { path: routes.dashboard, exact: true, name: 'Dashboard', component: Dashboard },
  { path: routes.setting, exact: true, name: 'Setting', component: Setting },
  { path: routes.customers, exact: true, name: 'Customers', component: Customers },
  { path: routes.categories, exact: true, name: 'Categories', component: Categories },
  { path: routes.pages, exact: true, name: 'Pages', component: Pages },
  { path: `${routes.pages}/:id`, exact: true, name: 'EditPage', component: EditPage },
  { path: routes.addPage, exact: true, name: 'AddPage', component: AddPage },
  { path: routes.newCustomer, exact: true, name: 'NewCustomer', component: NewCustomer },

  {
    path: routes.bulkProductUpdate,
    exact: true,
    name: 'BulkProductUpdate',
    component: BulkProductUpdate
  },
  {
    path: routes.uploadMedia,
    exact: true,
    name: 'MediaZip',
    component: MediaZip
  },
  {
    path: `${routes.newCustomer}/:id`,
    exact: true,
    name: 'EditNewCustomer',
    component: EditNewCustomer
  }
]

export default PrivateRoutes
